import { circumference } from '@softgames/math-utils';

const TEMPLATE_STYLE = `
  #xpromo-root {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  #xpromo-main {
    display: flex;
    width: 100%;
    height: 1px;
    flex: 1;
    flex-shrink: 1;
  }

  .xpromo-main-side {
    position: relative;
    display: flex;
    padding: 20px;
    min-width: 20px;
    min-height: 20px;
  }

  #xpromo-main-center {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  #xpromo-bottom {
    display: flex;
    justify-content: center;
    padding: 20px;
  }

  #xpromo-button-playgame {
    height: 8vh;
    width: 70vw;
    max-width: 300px;
    border-radius:28px;
    font-family: Verdana;
    font-weight: bold;
    font-size: 4vh;
    color: #ffffff;
    text-shadow: 0px 0px 5px #0000009c;
    cursor: pointer;
    user-select: none;
    box-shadow: 0px 0px 10px 0px #2b4424;
    background:linear-gradient(to bottom, #44c767 5%, #5cbf2a 100%);
    background-color: #44c767;
    border:1px solid #18ab29;
  }

  #xpromo-text-disclaimer {
    height: 8vh;
    max-width: 50%;
    font-family: Verdana;
    font-weight: bold;
    font-size: 3vh;
    word-wrap: normal;
    color: #ffffffff;
    margin-top: -50px;
    text-align: center;
    padding: 15px;
    background-color: #00000099;
  }

  #xpromo-button-playgame:focus {
    outline: 0;
  }

  #xpromo-button-playgame-animated {
    transition: opacity 300ms;
  }

  #xpromo-button-playgame-hidden {
    opacity: 0;
    cursor: auto;
  }

  #xpromo-button-playgame:hover {
    background: linear-gradient(to bottom, #5cbf2a 5%, #44c767 100%);
    background-color: #5cbf2a;
  }

  #xpromo-overlay {
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .fade-in {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 500ms;
  }

  .fade-out {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 500ms, opacity 500ms;
  }

  @media (orientation: landscape) {
    #xpromo-main {
      flex-direction: row;
    }
    #xpromo-main-left {
      align-items: flex-start;
      justify-content: center;
    }
    #xpromo-main-center {
      margin-top: 20px;
    }
    #xpromo-main-right {
      visibility: visible;
      display: flex;
      padding: 20px;
    }
  }

  @media (orientation: portrait) {
    #xpromo-main {
      flex-direction: column;
    }
    #xpromo-main-left {
      align-items: center;
      justify-content: flex-start;
    }
    #xpromo-main-center {
      margin-top: 0px;
    }
    #xpromo-main-right {
      visibility: hidden;
      overflow: hidden;
      display: none;
    }
  }
`;

const TEMPLATE_DIV = `
  <div id="xpromo-root">
    <div id="xpromo-main">
      <div id="xpromo-main-left" class="xpromo-main-side">
        <div id="xpromo-circle" style="position: absolute; width: 20px; height: 20px;">
          <svg viewBox="0 0 100 100" width="20" height="20">
            <circle id="xpromo-circle-bg" cx="50" cy="50" r="40" fill="none" stroke="#555" stroke-width="10"></circle>
            <circle id="xpromo-circle-fg" cx="50" cy="50" r="40" fill="none" stroke="#ccc" stroke-width="10" style="transform: rotate(-90deg); transform-origin: center"></circle>
          </svg>
        </div>
        <div id="xpromo-button-close" style="position: absolute; width: 20px; height: 20px; visibility: hidden; color: #ddd; cursor: pointer;">
          <svg viewBox="0 0 100 100" width="20" height="20">
            <polygon points="25,25 75,75" stroke="#ccc" stroke-width="10"/>
            <polygon points="25,75 75,25" stroke="#ccc" stroke-width="10"/>
          </svg>
        </div>
      </div>
      <div id="xpromo-main-center">
        <video id="xpromo-video" style="width: 100%; height: 100%; display: inline-block; vertical-align: center;" loop></video>
      </div>
      <div id="xpromo-main-right" class="xpromo-main-side"></div>
    </div>
    <div id="xpromo-bottom">
      <button id="xpromo-button-playgame">Play Game</button>
    </div>
    <div id="xpromo-overlay" class="fade-out"></div>
  </div>
`;

const TEMPLATE_DIV_FALLBACK = `
  <div id="xpromo-root">
    <div id="xpromo-main">
      <div id="xpromo-main-left" class="xpromo-main-side">
        <div id="xpromo-circle" style="position: absolute; width: 40px; height: 40px; margin-left: 15px;">
          <svg viewBox="0 0 100 100" width="40" height="40">
            <circle id="xpromo-circle-bg" cx="50" cy="50" r="40" fill="none" stroke="#555" stroke-width="10"></circle>
            <circle id="xpromo-circle-fg" cx="50" cy="50" r="40" fill="none" stroke="#ccc" stroke-width="10" style="transform: rotate(-90deg); transform-origin: center"></circle>
          </svg>
        </div>
        <div id="xpromo-button-close" style="position: absolute; width: 40px; height: 40px; margin-left: 15px; visibility: hidden; color: #ddd; cursor: pointer;">
          <svg viewBox="0 0 100 100" width="40" height="40">
            <polygon points="25,25 75,75" stroke="#ccc" stroke-width="10"/>
            <polygon points="25,75 75,25" stroke="#ccc" stroke-width="10"/>
          </svg>
        </div>
      </div>
      <div id="xpromo-main-center">
        <img id="xpromo-image" style=" height: 80%; display: inline-block; vertical-align: center;" loop></img>
      </div>
      <div id="xpromo-main-right" class="xpromo-main-side"></div>
    </div>
    <div id="xpromo-bottom">
      <div id="xpromo-text-disclaimer">We haven't been able to load your ad. Enjoy this reward for free!</div>
    </div>
    <div id="xpromo-overlay" class="fade-out"></div>
  </div>
`;

export function getHTMLRewardedAd(fallback = false): HTMLDivElement {
  const root = document.createElement('div');
  root.innerHTML = fallback ? TEMPLATE_DIV_FALLBACK : TEMPLATE_DIV;

  const style = document.createElement('style');
  style.innerHTML = TEMPLATE_STYLE;
  root.prepend(style);

  return root;
}

export function extractHTMLRewardedAdElements(elem: HTMLDivElement) {
    return {
        video: elem.querySelector<HTMLVideoElement>('#xpromo-video'),
        btnPlay: elem.querySelector<HTMLButtonElement>('#xpromo-button-playgame'),
        btnClose: elem.querySelector<HTMLButtonElement>('#xpromo-button-close'),
        overlay: elem.querySelector<HTMLDivElement>('#xpromo-overlay'),
    };
}

export function extractHTMLRewardedAdElementsFallback(elem: HTMLDivElement) {
  return {
      img: elem.querySelector<HTMLImageElement>('#xpromo-image'),
      btnClose: elem.querySelector<HTMLButtonElement>('#xpromo-button-close'),
      txt: elem.querySelector<HTMLDivElement>('#xpromo-text-disclaimer'),
      overlay: elem.querySelector<HTMLDivElement>('#xpromo-overlay'),
  };
}

export function createCircleProgressFunc(elem: HTMLDivElement) {
    const circleForeground = elem.querySelector<SVGCircleElement>('#xpromo-circle-fg');
    const radius = circleForeground.getAttribute('r');
    const circleCircumference = circumference(Number(radius));
    circleForeground.style.strokeDasharray = String(circleCircumference);

    return (progress: number) => {
        circleForeground.style.strokeDashoffset = String(circleCircumference * progress);
    };
}

export function createCircleCompleteFunc(elem: HTMLDivElement) {
    return () => {
        elem.querySelector<HTMLDivElement>('#xpromo-circle').style.visibility = 'hidden';
        elem.querySelector<HTMLDivElement>('#xpromo-button-close').style.visibility = 'visible';
    };
}
